import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-dialogue-box',
  imports: [CommonModule],
  templateUrl: './dialogue-box.html',
  styleUrl: './dialogue-box.scss',
  standalone: true,
})
export class DialogueBox {
  @Input() isDialogOpen = false;
  @Input() title = 'Dialog';
   @Input() message = '';
  @Input() confirmButtonText = 'Confirm';
  @Input() closeButtonText = 'Close';
  @Output() onClose = new EventEmitter<void>();
  @Output() onConfirm = new EventEmitter<void>();

  isClosing = false;

  closeDialog() {
    // Trigger fadeOut + slideDown animation
    this.isClosing = true;
    setTimeout(() => {
      this.isClosing = false;
      this.isDialogOpen = false;
      this.onClose.emit();
    }, 300); // match fadeOut duration
  }

  confirmAction() {
    this.onConfirm.emit();
  }
}
